import { render, staticRenderFns } from "./DividerZigZag.vue?vue&type=template&id=62424365&scoped=true"
import script from "./DividerZigZag.vue?vue&type=script&lang=ts"
export * from "./DividerZigZag.vue?vue&type=script&lang=ts"
import style0 from "./DividerZigZag.vue?vue&type=style&index=0&id=62424365&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62424365",
  null
  
)

export default component.exports